export default __webpack_public_path__ + "static/bytes-official-partner-90be3e180f9704f0531d1929766d374f.png";